import { UseMutationOptions, useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";
import { CancellationRequestSubmit } from "../../types/Types";

export function useSubmitCancellationRequest(
  options?: UseMutationOptions<unknown, unknown, CancellationRequestSubmit, unknown>
) {
  const queryClient = useQueryClient();
  return useMutation({
    ...options,
    mutationFn: (data: CancellationRequestSubmit) => {
      const body = {
        objectId: data.objectId,
        reasonCode: data.reasonId,
        improvementFeedback: data.improvementFeedback,
      };
      return axiosInstance
        .post(getAPIURL("/MembershipCancellation/request"), body)
        .then((res) => res.data);
    },
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ["cancellation-requests"] });
      queryClient.invalidateQueries({ queryKey: ["membership-cancellation-status"] });
      options?.onSuccess?.(...args);
    },
  });
}
